import { render, staticRenderFns } from "./PaymentReports.vue?vue&type=template&id=2ec1632a&lang=pug&"
import script from "./PaymentReports.vue?vue&type=script&lang=js&"
export * from "./PaymentReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentReports.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDataTable,
  VFlex,
  VLayout,
  VProgressLinear,
})
